<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content [innerHTML]="data.htmlContent"></mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" *ngIf="!data.onlyOk" [mat-dialog-close]="false">No</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ !data.onlyOk ? 'Si' : 'Chiudi' }}</button>
</mat-dialog-actions>
